<template>
    <el-dialog
            :visible.sync="dialogVisible"
            :before-close="handleClose"
            append-to-body
            :title="$t('wayPoint.header')">
        <el-form label-position="right" label-width="25%" ref="wayPointForm" :model="$data.wayPointParams" :rules="rules">
            <el-form-item :label="$t('wayPoint.editForm.fieldWayPointName')" prop="name">
                <el-input type="text" v-model="$data.wayPointParams.name"></el-input>
            </el-form-item>
            <el-form-item :label="$t('wayPoint.editForm.fieldWayPointModel')" prop="model">
                <el-select
                        v-model="$data.wayPointParams.model"
                        filterable
                        :placeholder="$t('wayPoint.editForm.placeHolder.fieldWayPointModel')">
                    <el-option
                            v-for="item in sportClass"
                            :key="item.id"
                            :label="item.name"
                            :value="item.id">
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item :label="$t('wayPoint.editForm.fieldWayPointType.name')">
                <el-radio-group size="medium" :disabled="disabledChangeType" v-model="$data.wayPointParams.markType">
                    <el-radio border :label=1>{{$t('wayPoint.editForm.fieldWayPointType.values.mark')}}</el-radio>
                    <el-radio border :label=2>{{$t('wayPoint.editForm.fieldWayPointType.values.gate')}}</el-radio>
                </el-radio-group>
            </el-form-item>
            <el-form-item :label="$t('wayPoint.editForm.fieldMark1Name')" prop="mark1.name">
                <el-input type="text" v-model="$data.wayPointParams.mark1.name"></el-input>
            </el-form-item>
            <el-form-item v-if="$data.wayPointParams.markType == 1" :label="$t('wayPoint.editForm.fieldleaveMarkSide.name')">
                <el-radio-group size="medium" v-model="$data.wayPointParams.leaveMarkSide">
                    <el-radio border :label=1>{{$t('wayPoint.editForm.fieldleaveMarkSide.values.onLeft')}}</el-radio>
                    <el-radio border :label=0>{{$t('wayPoint.editForm.fieldleaveMarkSide.values.onRight')}}</el-radio>
                </el-radio-group>
            </el-form-item>
            <el-form-item v-show="$data.wayPointParams.markType == 2" :label="$t('wayPoint.editForm.fieldMark2Name')" prop="mark2.name">
                <el-input type="text" v-model="$data.wayPointParams.mark2.name"></el-input>
            </el-form-item>
        </el-form>
        <span slot="footer">
            <el-button @click="handleSave" type="primary">{{$t('wayPoint.buttonSave')}}</el-button>
            <el-button @click="handleClose">{{$t('wayPoint.buttonClose')}}</el-button>
        </span>
    </el-dialog>
</template>

<script>
    import Utils from '@/utils';
    import SportClassUtils from '@/api/sportClass';

    export default {
        name: "WayPointModal",
        props: {
            dialogVisible: {
                type: Boolean,
                default: false
            },
            data: {
                type: Object,
                default: function () {
                    return {};
                }
            }
        },
        data() {
            return {
                disabledChangeType: false,
                sportClass: [],
                wayPointParams: {
                    id: null,
                    name: '',
                    model: null,
                    markType: 1,
                    mark1: {name: ''},
                    mark2: {name: ''},
                    leaveMarkSide: null,
                    gate: null
                }
            };
        },
        computed: {
            rules: function() {
                return {
                    name: [
                        {required: true, message: 'Please select way point name', trigger: 'change'}
                    ],
                    model: [
                        {required: true, message: 'Please select model', trigger: 'change'}
                    ],
                    mark1: {
                        name: [
                            {required: true, message: 'Please select mark1 name', trigger: 'change'}
                        ]
                    },
                    mark2: {
                        name: [
                            {
                                required: this.wayPointParams.markType == 2,
                                message: 'Please select mark2 name',
                                trigger: 'change'
                            }
                        ]
                    }
                }
            }
        },
        mounted: function () {
            this.loading = true;
            this.$data.wayPointParams.id = this.data.id;
            this.$data.wayPointParams.name = (this.data.name == undefined || this.data.name == null)?'':this.data.name;
            this.$data.wayPointParams.mark1 = this.data.mark1;
            this.$data.wayPointParams.leaveMarkSide = this.data.leaveMarkSide;
            this.$data.wayPointParams.gate = this.data.gate;
            if (this.data.gate != undefined && this.data.gate != null) {
                this.$data.wayPointParams.markType = 2;
            } else {
                this.$data.wayPointParams.markType = 1;
            }
            if (this.data.mark2 == undefined || this.data.mark2 == null) {
                this.$data.wayPointParams.mark2 = {name: ''};
            } else {
                this.$data.wayPointParams.mark2 = this.data.mark2;
            }
            if (this.data.id != undefined && this.data.id != null && !Utils.isTemporaryIndex(this.data.id)) {
                this.$data.disabledChangeType = true;
            }
            SportClassUtils.getSportClass().then(resp => {
                this.sportClass = Utils.selectMarkOnly(resp);
            }).finally(() => {
                this.loading = false;
            });
            if(this.data.mark1 != undefined && this.data.mark1 != null && this.data.mark1.sportClass != undefined && this.data.mark1.sportClass != null) {
                this.$data.wayPointParams.model = this.data.mark1.sportClass.id;
            }
        },
        methods: {
            handleClose: function () {
                this.$emit("visible-change", false);
            },
            handleSave: function () {
                this.$refs.wayPointForm.validate((valid) => {
                    if (valid) {
                        if (this.$data.wayPointParams.markType == 1) {
                            delete this.$data.wayPointParams.mark2;
                        }
                        let m = this.sportClass.filter((item) => {
                            if(item.id === this.$data.wayPointParams.model) return item;
                        });
                        this.$data.wayPointParams.sportClass = m[0];
                        this.$emit("visible-change", false);
                        this.$emit("on-close", this.$data.wayPointParams);
                    } else {
                        Utils.showMessage(this, "Ошибка ввода данных", "Проверьте правильность данных!");
                    }
                });
            }
        }
    }
</script>

<style scoped>

</style>
